export const createClientVisitor = (visitorId = null, authenticated) => {
  if (visitorId) visitorId += '';
  return {
    id: visitorId,
    context: {},
    isAuthenticated: authenticated,
  };
};
